module.exports = __webpack_public_path__ + "static/img/coo_add.96d380c7.png";